export const getAuthError = ({auth}) => auth.error;
export const isAuth = ({auth}) => auth.isLogin;
export const getUser = ({auth}) => auth.user;
export const getModels = ({auth}) => auth.user.models;
export const getCurrentModel = ({auth}) => auth.user.currentModel;